import { render } from "./FormDropdownComplex.vue?vue&type=template&id=4c812736"
import script from "./FormDropdownComplex.vue?vue&type=script&lang=js"
export * from "./FormDropdownComplex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__